module.exports = __webpack_public_path__ + "media/images/add-to-home-steps-5100137cd7c5b28a185532a92f4b02b3.png";